import React from 'react';

export default function AccessDeniedPage() {
  return (
    <main style={{ fontFamily: 'Inter, sans-serif', padding: '24px' }}>
      <h1>Hello World</h1>
      <p>Access denied page shell (Phase 1C).</p>
    </main>
  );
}
